export * from './discountBannerCopy';
